const theme = {
  colors: {
    primary: '#0D73D9',
    background: '#FFFFFF',
    shape: `#F2F2FA`,
    title: `#3D3D4D`,
    text: `#6C6C80`,
    textlink: `#0D73D9`,
    primary900: `#0049A7`,
    components: {
      blockquote: {
        background: `#E2F6FA`,
        text: `#2d3748`,
      },
    },
  },
};

export default theme;
